/**
 * Why `campaigns.previewMessage` wrote no sample (design outreach-v2 d2). music24-api sends the
 * reason in `error.data.reason`; the rate limit sends `error.data.retryAfterSeconds` with tRPC's
 * `TOO_MANY_REQUESTS` code.
 * - `profileNotReady`: `M24_PROFILE_NOT_READY`, the sound profile is not ready yet.
 * - `noSample`: `M24_PREVIEW_NO_SAMPLE`, Plug found no person of this kind yet.
 * - `songFacts`: `M24_PREVIEW_SONG_FACTS`, the song has no release date and no story line.
 * - `rateLimited`: too many samples; `seconds` is the wait.
 * - `failed`: `M24_PREVIEW_FAILED` and every other error (a model or network error).
 */
export type SamplePitchProblem =
  | { kind: 'profileNotReady' }
  | { kind: 'noSample' }
  | { kind: 'songFacts' }
  | { kind: 'rateLimited'; seconds: number }
  | { kind: 'failed' };

const DEFAULT_WAIT_SECONDS = 60;

function dataOf(error: unknown): Record<string, unknown> | null {
  if (typeof error !== 'object' || error === null) {
    return null;
  }
  const { data } = error as { data?: unknown };
  return typeof data === 'object' && data !== null ? (data as Record<string, unknown>) : null;
}

export function samplePitchProblem(error: unknown): SamplePitchProblem {
  const data = dataOf(error);
  switch (data?.reason) {
    case 'M24_PROFILE_NOT_READY':
      return { kind: 'profileNotReady' };
    case 'M24_PREVIEW_NO_SAMPLE':
      return { kind: 'noSample' };
    case 'M24_PREVIEW_SONG_FACTS':
      return { kind: 'songFacts' };
    default:
      break;
  }
  const wait = data?.retryAfterSeconds;
  if (typeof wait === 'number' || data?.code === 'TOO_MANY_REQUESTS') {
    return {
      kind: 'rateLimited',
      seconds: typeof wait === 'number' && wait > 0 ? Math.ceil(wait) : DEFAULT_WAIT_SECONDS,
    };
  }
  return { kind: 'failed' };
}
